<template>
  <c-row>
    <c-col>
      <div>
        <c-card-header>
          <strong>#{{data.faktur}}</strong>
        </c-card-header>
        <c-card-body>
          <h4><u>PEMBELIAN</u></h4>
          <div style="padding: 0 10px">
            <form-label label="Nomor" :text="data.faktur" col1="2" col2="7" />
            <form-label label="Tanggal" :text="data.created_at | dateFormat" col1="2" col2="7" />
            <form-label label="Suplier" :text="data.supplier && data.supplier.perusahaan" col1="2" col2="7" />
            <form-label label="Petugas" :text="data.user && data.user.name" col1="2" col2="7" />
            <form-label label="Total (Rp)" :text="data.total | thousandSeparator" col1="2" col2="7" />
          </div>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>No</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Qty</th>
                <th>Harga (Rp)</th>
                <th>Sub Total (Rp)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, k) in data.purchase_details" :key="k">
                <td>{{k + 1}}</td>
                <td>{{v.item && v.item.code}}</td>
                <td>{{v.item && v.item.name}}</td>
                <td class="center">{{v.qty_po}}</td>
                <td class="right">{{v.hpp | thousandSeparator}}</td>
                <td class="right">{{v.sub_total | thousandSeparator}}</td>
              </tr>
            </tbody>
          </table>
          <div>
          </div>
        </c-card-body>
      </div>
    </c-col>
  </c-row>
</template>
<script>
import FormLabel from '../../components/FormLabel.vue';
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    FormLabel,
  },
  data () {
    return {
      data: {
        amount: 0,
      },
      amount: 0,
      errors: {},
      deliveryRoute: null,
    };
  },
  mounted () {
    this.doPrint()
  },
  created () {
    const params = this.$route.params;
    if (params.id) {
      this.get(params.id);
    }
  },
  methods: {
    get (id) {
      HTTPAUTH.get("/api/v1/po/" + id + "/detail").then((res) => {
        this.data = res.data.data;
        this.data.due_date = new Date().toISOString();
        this.calculateTotal();
        this.data.amount = this.data.total;
        if (this.data.status == 3) {
          this.data.intransit = true;
        }
      });
    },
    calculateTotal () {
      const details = this.data.purchase_details;
      this.data.total = 0;
      for (var i in details) {
        const subTotal = details[i].sub_total;
        this.data.total += subTotal;
      }
    },
    doPrint () {
      setTimeout(function () {
        print();
      }, 500);
    },
  },
};
</script>